import axios from 'axios';
import { CodebookModel } from 'app/shared/model/shared.model';
import { PartiesModel, PartyModel } from 'app/edozvola/cases/parties/model/party.model';

export const getPartiesData = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/parties-data`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const savePartiesData = async (caseUuid: string, partiesData: PartiesModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/parties-data`, partiesData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyParties = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/party/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchParties = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/party/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteParty = async (idParty: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/party/${idParty}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getParty = async (idParty: string): Promise<PartyModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/party/${idParty}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveParty = async (idCase: string, party: PartyModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/party/${idCase}`, party)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchPartiesForAssignee = async (idCase: string, idParty: string): Promise<CodebookModel[]> => {
  let url = `api/party/party-assignee/${idCase}`;

  if (idParty) {
    url = `api/party/party-assignee/${idCase}?idParty=${idParty}`;
  }

  return await new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const findAssigneeNamesLinkedToSelectedParty = async (idParty: string): Promise<string> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/party/assignees-linked-to-selected-party/${idParty}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

